import {
  ExtractDocumentTypeFromTypedRxJsonSchema,
  RxJsonSchema,
  toTypedRxJsonSchema,
} from 'rxdb'

export const assessmentSignature = {
  version: 0,
  title: 'Signatures',
  primaryKey: 'rowId',
  type: 'object',
  properties: {
    rowId: {
      maxLength: 36,
      type: 'string',
    },
    assessmentId: {
      maxLength: 36,
      ref: 'assessment',
      type: 'string',
    },
    signatureConfirmProtocol: {
      type: ['string', 'null'],
    },
    signatureConfirmPartnerMediation: {
      type: ['string', 'null'],
    },
    signatureSection37CareRecipient: {
      type: ['string', 'null'],
    },
    signatureSection37Counselor: {
      type: ['string', 'null'],
    },
    signatureSection37Caregiver: {
      type: ['string', 'null'],
    },
    signatureSection45BillingPerson: {
      type: ['string', 'null'],
    },
    signatureSection45Caregiver: {
      type: ['string', 'null'],
    },
    consentToProcessingByInsuranceSection45: {
      type: ['string', 'null'],
    },
    updatedAt: {
      type: 'string',
    },
  },
  required: ['rowId', 'updatedAt', 'assessmentId'],
} as const

const schemaTyped = toTypedRxJsonSchema(assessmentSignature)

export type AssessmentSignature = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>

export const signatureSchema: RxJsonSchema<AssessmentSignature> =
  assessmentSignature
